import http from './http';

const Contest = {
  createOne: (data) => http.post('/api/contests/', { data }),
  deleteOne: (id) => http.delete(`/api/contests/${id}/`),
  inviteFriends: (id, data) => http.post(`/api/contests/${id}/invite/`, { data }),
  getOne: (id) => http.get(`/api/contests/${id}/`),
};

export default Contest;